var cookie = {
  setCookie(name, value, days) {
    let todayDate = new Date(days);
    // todayDate.setDate(todayDate.getDate() + days);
    // todayDate.setHours(24, 0, 0, 0);

    // var cookie_value =
    //   escape(value) +
    //   (days == null ? "" : "; expires=" + todayDate.toUTCString());
    // document.cookie = name + '=' + cookie_value;
    document.cookie =
      name +
      "=" +
      escape(value) +
      ";path=/; expires=" +
      todayDate.toUTCString() +
      ";";
  },

  getCookie(cookieName) {
    let cookieValue = null;
    if (document.cookie) {
      let array = document.cookie.split(escape(cookieName) + "=");
      if (array.length >= 2) {
        let arraySub = array[1].split(";");
        cookieValue = unescape(arraySub[0]);
      }
    }
    return cookieValue;
  },

  deleteCookie(cookieName) {
    let temp = this.getCookie(cookieName);
    if (temp) {
      this.setCookie(cookieName, temp, new Date(1));
    }
  },
};

export default cookie;
